import { render, staticRenderFns } from "./epaper-index.vue?vue&type=template&id=55e0f738&"
import script from "./epaper-index.vue?vue&type=script&lang=js&"
export * from "./epaper-index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports